import { render } from "./index.vue?vue&type=template&id=4de25518&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4de25518&scoped=true&lang=less"

import exportComponent from "G:\\workBench\\my_server_project\\eventvue\\myEvents\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de25518"]])

export default __exports__